import React from 'react';
import ComingSoon from '../components/UI/coming-soon/ComingSoon';

const TeamsPage: React.FC = () => {
  const lastYear = new Date();
  lastYear.setDate(lastYear.getDate() - 365);

  return (
    <div className='page'>
      <ComingSoon />
    </div>
  );
};

export default TeamsPage;
